import classNames from "classnames";
import { FC, HTMLProps } from "react";
import { TranslationScopes } from "@finbackoffice/enums";
import { DropdownOption, InputFieldError } from "@finbackoffice/site-core";
import { useTranslation } from "react-i18next";
import Translate from "../translate/Translate";
import styles from "./dropdown.module.sass";

type IDropdownProps = {
    name: string;
    options: DropdownOption[];
    wrapperClassname?: string;
    error?: InputFieldError;
    placeholder?: string;
    required?: boolean;
    label?: string;
} & Omit<HTMLProps<HTMLSelectElement>, "label">;

const Dropdown: FC<IDropdownProps> = ({
    options,
    wrapperClassname,
    placeholder,
    error,
    required,
    label,
    name,
    ...rest
}) => {
    const { t } = useTranslation();
    return (
        <div className={classNames(styles.dropdownContainer, wrapperClassname)}>
            {label && (
                <label htmlFor={name} className={styles.label}>
                    {label}:
                </label>
            )}
            <div className={classNames(required && "required")}>
                <select
                    name={name}
                    id={name}
                    className={classNames(styles.dropdown, error && styles.fieldError)}
                    {...rest}>
                    <option disabled value="">
                        {placeholder || t("base_dropdown_placeholder")}
                    </option>
                    {options.map((item) => (
                        <option key={item.value} value={item.value}>
                            <Translate
                                tid={typeof item.label === "string" ? item.label : item.label.tid}
                                namespace={
                                    typeof item.label !== "string"
                                        ? item.label.namespace
                                        : TranslationScopes.Common
                                }
                            />
                        </option>
                    ))}
                </select>
                <span className={styles.arrow} />
            </div>
            {error && (
                <span className={classNames(styles.error, "field-error")}>{error.message}</span>
            )}
        </div>
    );
};

export default Dropdown;
